import React, { useEffect} from "react";
import { BiPlusCircle } from "react-icons/bi";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Breadcrumb from "../common/Breadcrumb";

const Farewell = () => {  

  const images = [
    { id: 1, src: "images/farewell/farewell-1.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 2, src: "images/farewell/farewell-2.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 3, src: "images/farewell/farewell-3.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 4, src: "images/farewell/farewell-4.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 5, src: "images/farewell/farewell-5.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 6, src: "images/farewell/farewell-6.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 7, src: "images/farewell/farewell-7.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 8, src: "images/farewell/farewell-8.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 9, src: "images/farewell/farewell-9.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 10, src: "images/farewell/farewell-10.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 11, src: "images/farewell/farewell-11.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 12, src: "images/farewell/farewell-12.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 13, src: "images/farewell/farewell-13.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 14, src: "images/farewell/farewell-14.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 15, src: "images/farewell/farewell-15.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 16, src: "images/farewell/farewell-16.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 17, src: "images/farewell/farewell-17.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 18, src: "images/farewell/farewell-18.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 19, src: "images/farewell/farewell-19.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
    { id: 20, src: "images/farewell/farewell-20.png", alt: "Farewell", title: "Farewell", group: "Farewell" },
  ];

  useEffect(() => {
    NativeFancybox.bind("[data-fancybox='gallery']", {
      infinite: true,
      Toolbar: {
        display: {
          left: ["infobar"],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        autoStart: false,
      },
      caption: (fancybox, slide) => {
        return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
      },
    });

    return () => {
      NativeFancybox.destroy();
    };
  }, []);


  return (
    <>
      <Breadcrumb
        pageTitle="Gallery"
        breadcrumbItems={[
          { label: "Home", link: "/" },
          { label: "Farewell Function 2025-26" },
        ]}
        backgroundImage="images/banner/slide-2.png"
      />

      <section className="space-ptb">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <div className="section-title">
                <h2>Farewell Function 2025-26</h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="my-shuffle-container row columns-4 popup-gallery full-screen">
                {images.map((image) => (
                  <div key={image.id} className="grid-item" data-group={image.group}>
                    <div className="portfolio-item">
                      <div className="position-relative">
                        <img
                          className="img-fluid"
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                        />
                        <div className="portfolio-overlay">
                          <a
                            data-fancybox="gallery"
                            data-caption={image.title}
                            href={image.src}
                            title={image.title}
                            className="portfolio-img"
                          >
                            <i>
                              <BiPlusCircle size={40} />
                            </i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Farewell;
